/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import ActionModel, { SendingState } from 'cio/models/action';

interface HoldoutArgs {
  actionAbstract: {
    action: ActionModel;
    [key: string]: any;
  };
  isSaving: boolean;
  hasReadOnlyPermission: boolean;
}

export default class Holdout extends Component<HoldoutArgs> {
  /**
   * Holdout messages can be sent automatically without content. What we want to
   * prevent here is disabling the holdout setting when a message has no content
   * and is set to be sent automatically, which would deliver an empty message
   * to users.
   */
  @computed('args.actionAbstract.{sendingState,holdout,action.hasNoContent}')
  get disabledToPreventInvalidState() {
    let { sendingState, holdout } = this.args.actionAbstract;
    let { hasNoContent } = this.args.actionAbstract.action;

    return sendingState === SendingState.Automatic && hasNoContent && holdout;
  }

  get checkboxDisabled() {
    return this.args.hasReadOnlyPermission || this.args.isSaving || this.disabledToPreventInvalidState;
  }
}
